function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
  transform: "translate(-557 -4665) translate(0 4345) translate(340 130) translate(0 178)"
}, React.createElement("g", null, React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 1.8
}, React.createElement("g", {
  transform: "translate(170) translate(47 12) translate(17 16)"
}, React.createElement("rect", {
  width: 17.28,
  height: 6.48,
  x: .36,
  rx: 1.44
}), React.createElement("rect", {
  width: 17.28,
  height: 6.48,
  x: 5.04,
  y: 10.8,
  rx: 1.44
}), React.createElement("path", {
  strokeLinecap: "round",
  d: "M.36 9L.36 12.6M5.04 19.8L5.04 23.4"
})))))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/simultaneous-editing.1e8043ba.svg";
export { SvgComponent as ReactComponent };